<template>
    <div v-if="show"
        class="fixed z-100 inset-0 flex flex-col bg-black bg-opacity-25"
        :class="is_iPad ? 'items-end justify-start' : 'items-center justify-end'"
        @click="hideMessage"
    >
        <div class="flex flex-col items-center my-1 px-3"
            :class="is_iPad ? 'w-auto' : 'w-full'"
        >
            <div v-if="is_iPad"
                class="arrow ipad-position transform rotate-180 -mb-1 z-100 shadow-lg self-end"
            >
            </div>

            <div class="w-full relative tooltip rounded-lg bg-white shadow-lg py-5"
                :class="is_iPad ? 'px-12' : 'px-7'"
            >
                <div class="text-gray-500 absolute z-100 w-5 h-5 top-0 mx-2 my-2"
                    :class="is_iPad ? 'left-0' : 'right-0'"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div class="font-semibold text-blue-600 text-center leading-snug border-b border-gray-400 pb-3 mb-3"
                    :class="is_iPad ? 'text-xl' : 'text-md'"
                >
                    Add Contract2Close to your Home&nbsp;Screen!
                </div>

                <div class="text-base text-blue-600 text-center leading-none pb-2">
                    Tap the
                    <div class="inline-block text-blue-600 w-8 h-8 -mx-1 -mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" enable-background="new 0 0 50 50" fill="currentColor"><path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"/><path d="M24 7h2v21h-2z"/><path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"/></svg>
                    </div>
                    button, then select
                </div>

                <div class="flex items-center justify-center text-black leading-none py-1">
                    Add to Home Screen<i class="text-black text-lg far fa-plus-square mb-px ml-2"></i>
                </div>
            </div>

            <div v-if="is_iPhone"
                class="arrow -mt-1 z-100 shadow-lg"
            >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            has_already_alerted: false,
            show: false,
        }
    },

    computed: {
        is_in_standalone_mode() {
            return ('standalone' in window.navigator) && (window.navigator.standalone);
        },
        is_iPhone() {
            return /iphone/.test(this.user_agent);
        },
        is_iPad() {
            return ! this.user_agent.match('crios')
                && (this.user_agent.match(/mac/)
                    && navigator.maxTouchPoints
                    && navigator.maxTouchPoints > 2
                );
        },
        user_agent() {
            return window.navigator.userAgent.toLowerCase();
        },
    },

    methods: {
        showMessage() {
            this.getCachedStatus();

            if (this.has_already_alerted) {
                return;
            }

            if ((this.is_iPhone || this.is_iPad) && ! this.is_in_standalone_mode) {
                this.show = true;
                this.listenForEscape();
            }
        },
        hideMessage() {
            this.show = false;
            this.setCachedStatus();
            document.removeEventListener('keydown', this.escapeHandler);
        },
        setCachedStatus() {
            localStorage.c2c_a2h = true;
        },
        getCachedStatus() {
            if (localStorage.c2c_a2h) {
                this.has_already_alerted = true;
            }
        },
        listenForEscape() {
            document.addEventListener('keydown', this.escapeHandler);
        },
        escapeHandler(e) {
            if (e.key === 'Escape') {
                this.hideMessage();
            }
        },
    },

    mounted() {
        this.showMessage();
    },
}
</script>

<style scoped>
.arrow {
    border-color: #fff transparent;
    border-style: solid;
    border-width: 13px 13px 0;
    bottom: -13px;
}

@media (orientation: landscape) {
    .ipad-position {
        margin-right: 124px;
    }
}

@media (orientation: portrait) {
    .ipad-position {
        margin-right: 129px;
    }
}
</style>
